module.exports = __webpack_public_path__ + "img/again.a04307f9.svg";